import { defineMessages } from 'react-intl';

export default defineMessages({
  inputSave: {
    id: 'USER_LIST.inputSave',
    defaultMessage: 'Save',
  },
  inputCancel: {
    id: 'USER_LIST.inputCancel',
    defaultMessage: 'Cancel',
  },
  radioGroupTitle: {
    id: 'USER_LIST.radioGroupTitle',
    defaultMessage: 'User Permissions:',
  },
  resetPasswordTitle: {
    id: 'USER_LIST.resetPassword',
    defaultMessage: 'Reset password',
  },
  radio: {
    Attendee: {
      id: 'USER_LIST.radio.radioAttendee',
      defaultMessage: 'Attendee',
    },
    Analyst: {
      id: 'USER_LIST.radio.radioAnalyst',
      defaultMessage: 'Analyst',
    },
    SuperAdmin: {
      id: 'USER_LIST.radio.SuperAdmin',
      defaultMessage: 'Super Admin',
    },
  },
});



// WEBPACK FOOTER //
// ./components/organisms/EditUser/messages.js